export default {
  token: 31536000000, // 1 year
  locale: -1, // forever
};
